import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { SharesPageComponent } from "./components/shares-page/shares-page.component";

export function getSharesRoutes(): Route[] {
  return [
    {
      title: 'Shares',
      path: 'shares/:id',
      component: SharesPageComponent,
      canActivate: [authGuard]
    },
  ];
}
